import * as React from 'react';
import FooterContent from './FooterContent';
import '../styles/App.css';

const footGlassLeft = require('../images/FootGlass_Left.png');
const footGlassRight = require('../images/FootGlass_Right.png');

class FooterRegion extends React.Component {
  render() {
    return (
        <div className="FooterOuterRegion">
            <div className="FooterInnerRegion">
                <table className="FooterGlassTableRegion" cellPadding="0" cellSpacing="0">
                    <tbody>
                        <tr>
                            <td style={{ width: '40px', height: '61px' }}>
                                <img src={footGlassLeft} className="FooterGlassLeftImg" alt="" />
                            </td>
                            <td className="FooterGlassCenterTableCell">
                                <FooterContent />
                            </td>
                            <td style={{ width: '72px', height: '61px' }}>
                                <img src={footGlassRight} className="FooterGlassRightImg" alt="" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
  }
}

export default FooterRegion;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/FooterRegion.tsx